import { call, takeEvery, put, select, delay } from "redux-saga/effects";
import * as vehiclesActions from "../actions/vehiclesActions";
import {
  getAllVehiclesRequest,
  getFilterVehiclesRequest,
  getArchiveVehiclesRequest,
  getActualVehiclesRequest,
  getUserFilterVehiclesRequest,
  getUserSearchVehiclesRequest
} from "../../api/vehicles/vehicles";

import history from "../../../../common/history";
import { errorProcessing } from "../../../Employees/api/errorProcessing";

const getActiveProfileId = state => {
  return (
    state.Authorization &&
    state.Authorization.activeProfile &&
    state.Authorization.activeProfile.profileId
  );
};

function* getAllVehiclesSaga(action) {
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      const response = yield call(getAllVehiclesRequest, activeProfileId, action.payload);
      yield put(
        vehiclesActions.getAllVehiclesSuccess({
          actualVehicles:
            response && response.filter(vehicle => !vehicle.isArchive),
          archiveVehicles:
            response && response.filter(vehicle => vehicle.isArchive)
        })
      );
    } catch (err) {
      yield put(vehiclesActions.getAllVehiclesError(errorProcessing(err)));
    }
  } else {
    yield delay(500);
    activeProfileId = yield select(getActiveProfileId);
    activeProfileId
      ? yield put(vehiclesActions.getAllVehicles())
      : history.push("/authorization/profiles");
  }
}

function* getFilterVehiclesSaga(action) {
  let filters = action.payload;
  let activeProfileId = yield select(getActiveProfileId);

  if (activeProfileId) {
    try {
      const response = yield call(
        getFilterVehiclesRequest,
        activeProfileId,
        filters
      );
      yield put(
        vehiclesActions.getFilterVehiclesSuccess({
          actualVehicles:
            response && response.filter(vehicle => !vehicle.isArchive),
          archiveVehicles:
            response && response.filter(vehicle => vehicle.isArchive)
        })
      );
    } catch (err) {
      yield put(vehiclesActions.getFilterVehiclesError(errorProcessing(err)));
    }
  } else {
    yield delay(500);
    activeProfileId = yield select(getActiveProfileId);
    activeProfileId
      ? yield put(vehiclesActions.getFilterVehicles(action.payload))
      : history.push("/authorization/profiles");
  }
}

function* getActualVehiclesSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getActualVehiclesRequest, payload);
    yield put(vehiclesActions.getActualVehiclesSuccess(response));
  } catch (error) {
    yield put(vehiclesActions.getActualVehiclesError(error));
  }
}

function* getArchiveVehiclesSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getArchiveVehiclesRequest, payload);
    yield put(vehiclesActions.getArchiveVehiclesSuccess(response));
  } catch (error) {
    yield put(vehiclesActions.getArchiveVehiclesError(error));
  }
}

/* function* getFilterVehiclesSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getUserFilterVehiclesRequest, payload);
    yield put(vehiclesActions.filterVehiclesSuccess(response));
  } catch (error) {
    yield put(vehiclesActions.filterVehiclesError(error));
  }
} */
function* applyFilterVehiclesSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getUserFilterVehiclesRequest, payload);
    yield put(vehiclesActions.applyFiltersSuccess(response));
  } catch (error) {
    yield put(vehiclesActions.applyFiltersError(error));
  }
}

function* applySearchVehiclesSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getUserSearchVehiclesRequest, payload);
    yield put(vehiclesActions.applySearchSuccess(response));
  } catch (error) {
    yield put(vehiclesActions.applySearchError(error));
  }
}

export function* vehiclesWatcher() {
  yield takeEvery(
    vehiclesActions.getAllVehicles.toString(),
    getAllVehiclesSaga
  );
  yield takeEvery(
    vehiclesActions.getFilterVehicles.toString(),
    getFilterVehiclesSaga
  );
  yield takeEvery(
    vehiclesActions.getActualVehicles.toString(),
    getActualVehiclesSaga
  );
  yield takeEvery(
    vehiclesActions.getArchiveVehicles.toString(),
    getArchiveVehiclesSaga
  );
  yield takeEvery(
    vehiclesActions.applyFilters.toString(),
    applyFilterVehiclesSaga
  );
  yield takeEvery(
    vehiclesActions.applySearch.toString(),
    applySearchVehiclesSaga
  );
}
